import React, {
  forwardRef,
  useImperativeHandle,
  useState,
  useRef,
  useEffect,
} from 'react';
import TagEditor from 'components/ui/TagEditor';
import Constants from 'constants/AdminConstants';

export default forwardRef(
  ({ value, stopEditing, data, onShipmentChangeTags }, ref) => {
    const [tags, setTags] = useState(value ?? []);
    const isMounted = useRef(true);
    const wrapperRef = useRef(null);

    const onChange = (data, tags) => {
      onShipmentChangeTags(data, tags);
      if (isMounted.current) {
        setTags(tags);
      }
      stopEditing();
    };

    useImperativeHandle(ref, () => {
      return {
        getValue() {
          return tags;
        },
      };
    });

    useEffect(() => {
      // Function to handle clicks outside the editor
      const handleClickOutside = (event) => {
        if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
          stopEditing();
        }
      };

      document.addEventListener('mousedown', handleClickOutside);

      return () => {
        document.removeEventListener('mousedown', handleClickOutside);
      };
    }, []);

    return (
      <div ref={wrapperRef} className="p-1 pb-0 bg-white">
        <TagEditor
          client="edi-settings"
          object={data}
          tags={tags}
          suggestions={Constants.shipmentTagSuggestions}
          handleChange={onChange}
          hideLabel={false}
          wrapperClasses="mb-0 min-w-40"
        />
      </div>
    );
  },
);
